<template>
  <div class="travelers">
    <content-section
      title="Elenco dei passeggeri"
      description="Verifica che nomi e date di nascita siano corrispondenti a quelli riportati nel documento di identità con cui verrà fatto l'imbarco"
    >
      <template>
        <div class="travelers__wrapper">
          <div
            v-for="(traveler, index) in travelers"
            :key="_uid + index"
            class="travelers__user-info"
          >
            <div class="travelers__user-name">
              <span>Nome e cognome:</span>
              <span class="semibold">
                {{ traveler_name(traveler) }}
              </span>
            </div>
            <div class="travelers__user-age">
              <span>Data di nascita:</span>
              <span class="semibold">{{ reverse_date(traveler.dateOfBirth) }}</span>
            </div>
          </div>
        </div>
      </template>
    </content-section>
  </div>
</template>

<script>
import { reverse_date } from "@/utilities/commons";
import { traveler_name } from "@liveflight/utilities";
import ContentSection from "@liveflight/components/blocks/wrappers/content-section.vue";

export default {
  name: "travelers",

  components: {
    "content-section": ContentSection,
  },

  props: {
    travelers: {
      type: Array,
      default: () => [],
    }
  },

  created() {
    this.reverse_date = reverse_date;
    this.traveler_name = traveler_name;
  },
};
</script>

<style lang="scss">

  .travelers {

    &__wrapper {
      margin-top: $grid-gutter-width / 2;

      @include media-breakpoint-up(xl) {
        display: flex;
      }
    }

    &__user {

      &-info {
        margin-top: $grid-gutter-width / 2;

        @include media-breakpoint-up(xl) {
          flex-basis: 33.33333%;
          margin-top: 0;
        }

        span:first-child {
          margin-right: $grid-gutter-width / 4;
        }
      }
    }
  }
</style>